import axios from 'axios';

export const read = () => axios.get('https://smartmap.at/api/layers/2/data', {
  headers: {
    'requested-content-type': 'application/geojson; charset=utf-8',
  },
});

export const getMicroraster = (catchment: string) =>
  axios.get('https://smartmap.at/api/catchments/' + catchment + '/microrasters');

export const getAgeMicroraster = (catchment: string) =>
  axios.get('https://smartmap.at/api/catchments/' + catchment + '/age-microrasters');

export const getBuyingPowerMicroraster = (catchment: string) =>
  axios.get('https://smartmap.at/api/catchments/' + catchment + '/buying-power-microrasters');

export const getCompetitors = (catchment: string, specialty?: string) =>
  axios.get(`https://smartmap.at/api/catchments/${catchment}/competitors${specialty ? `?specialty=${specialty}` : ''}`);

export const geocode = (address: any) =>
  axios.get(`https://smartmap.at/api/geocode?street=${address.street}&streetNumber` +
    `=${address.streetNumber}&zip=${address.zip}&city=${address.city}`);

export const getArea = (coords: any) =>
  axios.get(`https://smartmap.at/api/locations?x=${coords.x}&y=${coords.y}`);

export const createReport = (catchment: string, base64Image: string, specialty: string) =>
  axios.post('https://smartmap.at/api/catchments/' + catchment + '/report-basic', {
      base64: base64Image,
      specialty,
    },
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'requested-content-type': 'application/json',
      },
    },
  );

export const postCatchment = (data: any) => axios.post('https://smartmap.at/api/catchments', data, {
  headers: {
    'requested-content-type': 'application/geojson; charset=utf-8',
  },
});

export const deleteCatchment = (catchment: string) => axios.delete(`https://smartmap.at/api/catchments/${catchment}`, {
  headers: {
    'requested-content-type': 'application/geojson; charset=utf-8',
  },
});
